import MobileDetect from 'mobile-detect';
import config from '../../config';

export const checkIsApp = (headers) => {
  const md = new MobileDetect(headers['user-agent']);
  const isUIWebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(headers['user-agent']);
  const isAndroid = md.os() === 'AndroidOS';
  const isIPhone = md.is('iPhone');
  return ((isAndroid && (headers['x-requested-with'])) || (isIPhone && isUIWebview));
};

export const hasEmmaUserAgent = () => {
  // eslint-disable-next-line prefer-destructuring
  const userAgent = navigator.userAgent;
  const regex = new RegExp(config.userAgentPattern, 'g');
  return regex.test(userAgent);
};

export const checkLoginIsApp = () => {
  return hasEmmaUserAgent();
};
